export const cyrillic = (value) => !/[а-яА-ЯіІЄєїЇҐґ]/.test(value)
export const invalidSymbols = (value) => /^[a-zA-Zа-яА-ЯіІЄєїЇҐґ0-9!@#$%^&*(){}[\]<>.,\\\/?~`=+\-_|"':;]*$/i.test(value)
